const SET_FILE = 'react-template/app/SET_FILE'

const initialState = {}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_FILE:
      return {
        ...state,
        [action.file.fileUrl]: {
          fileLocalUrl: action.file.fileLocalUrl,
          loading: action.file.loading,
          type: action.file.type,
          name: action.file.name
        }
      }
    default:
      return state
  }
}

export function setFile(file) {
  return {
    type: SET_FILE,
    file
  }
}
